import { useCurrentUser } from 'javascripts/hooks';
import { useMutation } from '@apollo/client';
import { userHasPermission, SHARE_PHOTOS } from 'helpers/permissions';
import { MUTATION_SET_ASSETS_INTERNAL_STATE } from './gql/mutateSetAssetsInternalState.graphql';

const NO_ACTION = null;
const NO_MODAL = () => {};
const EMPTY_RESULT = [NO_ACTION, NO_MODAL];

export default function useMenuActionMarkInternal({
  assets,
  onSuccess,
  internal,
}) {
  const user = useCurrentUser();

  const [setAssetsInternal] = useMutation(MUTATION_SET_ASSETS_INTERNAL_STATE, {
    onCompleted: () => {
      onSuccess && onSuccess();
    },
  });

  const hasPermission = userHasPermission(user, SHARE_PHOTOS);
  const validSelection = assets.length > 0;

  if (!hasPermission || !validSelection) {
    return EMPTY_RESULT;
  }

  const action = async () => {
    const assetIds = assets.map((asset) => asset.id);
    setAssetsInternal({
      variables: {
        input: {
          assetIds,
          internal,
        },
      },
    });
  };

  return [action, NO_MODAL];
}
